var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.capacitors),function(capacitor){return _c('Capacitor',{key:capacitor.key,attrs:{"value":capacitor},on:{"delete":_vm.onDelete,"duplicate":_vm.onDuplicate,"update":_vm.onUpdate}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }